export default "__VITE_ASSET__CYitD0Yr__"